import React, { useEffect } from "react";
import "./LoadingLogo.css";
import Logo from "../triquetra-full-logo.svg";

function AnimatedTriquetra() {
  useEffect(() => {
    const shape = document.getElementById("shape");
    shape.setAttribute("stroke-dashoffset", 0);
  }, []);

  return (
    <>
      <div className="LoadingLogo-background">
        <div>
          <img
            src={Logo}
            alt="Company Logo"
            className="logo-loading"
            id="logoImage"
          />
        </div>
      </div>

      <a href="">
        <svg
          version="1.1"
          id="triquetra"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="11 97 634 600"
        >
          <circle
            id="shape"
            cx="330"
            cy="470"
            r="230"
            stroke-dasharray="1500"
            stroke-dashoffset="1500"
          />
          <g transform="translate(-11.44,612.44)scale(1.19,-1.19)">
            <path
              id="outside"
              strokeWidth="9"
              d="M525.2-12.5c0,132.5-107.5,240-240,240s-240-107.5-240-240c36.5-21.1,77.9-32.2,120-32.2 c132.5,0,240,107.5,240,240c0,85.7-45.7,165-120,207.8c-74.3-42.9-120-122.1-120-207.8c0-132.5,107.5-240,240-240 C447.4-44.7,488.8-33.6,525.2-12.5z"
            />
          </g>
          <g transform="translate(-11.44,612.44)scale(1.19,-1.19)">
            <path
              id="inside"
              strokeWidth="9"
              d="M516.8-9.2c0,132.5-112.9,230.9-231.6,229.8C165.9,219.4,53.6,125,53.6-7.5C90.1-28.6,124.9-38.7,167-37.7 c118.2,2.8,231.1,96.6,231.1,229.1c0,85.7-43.4,162.1-112.9,203.4c-68.3-41.3-111.9-118.1-111.9-203.9 c0-132.5,114.1-228.7,233.5-228.6C448.9-37.7,479.8-26.6,516.8-9.2z"
            />
          </g>
        </svg>
      </a>
    </>
  );
}

export default AnimatedTriquetra;
